import { useTranslation } from 'react-i18next'
import { LayersControl, LayerGroup } from 'react-leaflet'
import { mapLayers } from '../../constraints'
import { Suspense, lazy, memo } from 'react'
const TileLayerCustom = lazy(() => import('./TileLayerCustom'))

export const MapTileLayers: React.FC<{ maxZoom: number }> = memo(({ maxZoom = 16 }) => {
  const { t } = useTranslation(['map', 'common'])
  return (
    <>
      <LayersControl.Overlay name={`<b><u>${t('map-layers')}</u></b>`}>
        <LayerGroup></LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.BaseLayer name={t('map-norway')} checked>
        <Suspense fallback={<></>}>
          <TileLayerCustom
            attribution="Map data &copy; Kartverket"
            url={mapLayers.map_norway}
            noWrap={true}
            maxZoom={maxZoom}
            minZoom={4}
          />
        </Suspense>
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name={t('map-norway-sea')}>
        <Suspense fallback={<></>}>
          <TileLayerCustom
            attribution="Map data &copy; Kartverket"
            url={mapLayers.map_norway_sea}
            noWrap={true}
            maxZoom={maxZoom}
            minZoom={4}
          />
        </Suspense>
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name={t('google-satellite-map')}>
        <Suspense fallback={<></>}>
          <TileLayerCustom
            attribution="&copy; Google"
            url={mapLayers.map_google_satellite}
            maxZoom={maxZoom}
            subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
          />
        </Suspense>
      </LayersControl.BaseLayer>
    </>
  )
})
